export enum VersionStatus {
  ACTIVE = "active",
  MAINTENANCE = "maintenance",
}
